import { IUseContentPagePreviewProps } from 'components/Pages/Admin/shared/ItinerariesItemLanding/types';
import { parseLatLngFromString } from 'utils/maps';

import { getHandledPageName } from '../../../utils';
import * as types from './../../types';

type Props = types.PropertyFormValues | (IUseContentPagePreviewProps & types.PropertyFormValues);

export const handleFormValues = (formValues: Props) => {
  const { lat: latitude, lng: longitude } = parseLatLngFromString(formValues.coords);
  const handle = getHandledPageName(formValues);

  // areaConfirmed should be false because we create simple area
  const handledArea = {
    areaName: formValues.area?.name,
    areaId: formValues.area?.id,
    areaConfirmed: formValues.area?.confirmed,
  };

  const handledMasterProperty = {
    masterPropertyId: formValues.masterProperty?.id,
    masterPropertyName: formValues.masterProperty?.name,
  };

  const res = {
    ...formValues,
    ...handledArea,
    ...handledMasterProperty,
    handle,
    latitude,
    longitude,
    // need for api, same as in default flow (checkbox not required)
    agreement: true,
  };

  return res;
};
